import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from "@mui/material";
import { useSelector } from "react-redux";

const Modal = ({ isOpen, onClose, children, submitChange }) => {
  const { userDetails } = useSelector((state) => state.dcoi);

  const viewSubmissionButton = () => {
    submitChange();
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      {/* Header */}
      <DialogTitle sx={{ fontWeight: 500, fontSize: "22px", color: "#585353", padding: "10px" }}>
        {children?.Key24?.replace("{0}", userDetails?.CycleYear)}
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ fontSize: "14px", color: "#585353", padding: "20px 12px" }}>
          {children?.Key25}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ padding: "16px", justifyContent: "flex-end" }}>
        <Button
          sx={{
            color: "white",
            backgroundColor: " #212129",
            padding: "10px",
            borderRadius: "20px",
            "&:hover": { backgroundColor: "darkgray" },
          }}
          onClick={viewSubmissionButton}
        >
          View Submission
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
